import {
    ICubeCheatResponse,
    ICubeGameInit,
    ICubeGameResult,
    ICubeResponse,
    ICubeSlotGame,
    ICubeState,
} from "@spawn/backend-adapter-cube";
import { INetworkStateCheat } from "@spawn/networking";
import { INudgeFeatureCube } from "@spawn/nudge";
import { IRevealFeatureCube } from "@spawn/reveal";

export interface IFGMultiplierCube {
	currentWinMultiplier: number;
	nextWinMultiplier: number;
}

export type INrgFeaturesCube = IRevealFeatureCube & INudgeFeatureCube & IFGMultiplierCube;

export type INrgTriggerSpinCube = IRevealFeatureCube &
	INudgeFeatureCube & {
		reels: string[][];
	};

/** @see ICubeState */
export interface INrgCubeState extends ICubeState {
	slotGame: ICubeSlotGame & {
		nudgeAndReveal: INrgFeaturesCube & {
			triggerSpin?: INrgTriggerSpinCube;
		};
	};
}

/** @see ICubeGameInit */
export interface INrgCubeGameInit extends ICubeGameInit {
	state: INrgCubeState;
	transition?: INrgCubeState;
}

/** @see ICubeGameResult */
export interface INrgCubeGameResult extends ICubeGameResult {
	state: INrgCubeState;
	transition: INrgCubeState;
}

export type GameInitResponsesCube = {
	init: ICubeResponse<string>;
	gameInit: ICubeResponse<INrgCubeGameInit>;
	cheats?: ICubeCheatResponse;
	generatedCheats: INetworkStateCheat[];
};
